export default "__VITE_ASSET__CUOrUYEB__"